import { Highlight } from 'react-instantsearch'

import type { Hit, BaseHit } from 'instantsearch.js'
import type { ReactElement } from 'react'
import type { IIap } from '~/types/iap'

import { IapStatusBadge } from '~/components/Badges'

interface Props {
  hit: Hit<BaseHit> &
    IIap & {
      onClick: VoidFunction
    }
}

const DEFAULT_PERIOD = 'P0D'

const CustomHit = ({ hit }: Props): ReactElement => {
  const { onClick, status } = hit

  return (
    <div className="hit-container" onClick={onClick}>
      <div className="hit-row">
        <div className="hit-row__key">
          <Highlight attribute="title" hit={hit} />
        </div>
        {status ? <IapStatusBadge value={status} /> : null}
      </div>
      <div className="hit-row">
        <div className="hit-row__infos">{`${hit.trial_period || DEFAULT_PERIOD} - ${hit.price} - ${
          hit.subscription_period || DEFAULT_PERIOD
        }`}</div>
      </div>
      <div className="hit-row">
        <div className="hit-row__value">
          <Highlight attribute="id" hit={hit} />
        </div>
      </div>
    </div>
  )
}

export default CustomHit
